import { GetterTree } from 'vuex';
import { SearchState, RootState } from '../types';

export const getters: GetterTree<SearchState, RootState> = {

	getSearchItems(state): object | null {
		return state.searchItems;
	}
};